module.exports = __webpack_public_path__ + "static/media/holiday-gift-card-mb-fr.295838cc.jpg";